import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../../assets/images/logoXL.svg";

import { ReactComponent as LinkIcon } from "../../../assets/icons/links.svg";
import { ReactComponent as ArrowLeft } from "../../../assets/icons/arrowleft.svg";
import HelpImg from "../../../assets/images/signUp/email.svg";

const Verification = ({ onPrev, onEmail, onNext }) => {
  const [code, setCode] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    onNext();
  };

  return (
      <div className="h-screen flex flex-col items-center justify-between py-5">
        <div className="flex flex-col justify-center items-center w-[425px]">
          <div className="flex flex-col items-center justify-center gap-4">
            <Link to="/">
              <Logo className=""/>
            </Link>
            {/* <div className="border"> */}
              <img src={HelpImg} className="w-[304px]" />
            {/* </div> */}
            <h3 className="text-primary text-[36px] font-bold"> Help is on the way</h3>
            <p className="text-secondarytwo text-f14 mt-2 text-left">
              We're diligently searching our records to locate the TREVEX
              account associated with <b> {onEmail}.</b>
              <br />
              <br />
              Should we discover a match, you can expect an email from us
              containing detailed instructions. If you haven't received any
              communication within the next 15 minutes, please verify that you
              entered the correct email address and take a moment to check your
              spam folder as well.
            </p>
          </div>
          <Link
            to="/login"
            className="inline-flex items-center justify-center mr-2 gap-2 font-bold mt-5 text-primaryText"
          >
            {" "}
            <ArrowLeft /> Go Back to Log In{" "}
          </Link>
        </div>

        <div className="text-f12">
          <p>{`Copyright @ ${new Date().getFullYear()} TREVEX Technology Limited`} </p>
          <Link
            to="/"
            className="inline-flex items-center justify-center mr-2 gap-2 font-bold text-primaryText"
          >
            Privacy Policy <LinkIcon />{" "}
          </Link>
        </div>
      </div>
  );
};

export default Verification;
